import { useRef, useState } from 'react'

type fileProps = {
    setInputFile: (File:File) => void;
    deleteFile: () => void;
}

export function FileUp (props:fileProps){

        const inputFileRef = useRef<HTMLInputElement>(null);

        //  ファイル選択後
        const onFileInputChange = (e:React.ChangeEvent<HTMLInputElement>) => {

            const input = document.querySelector('#inputFile');
            const figureImage = document.querySelector('#figureImage');
            const fileName = document.querySelector('.frm-file-val');

            if(e.currentTarget.files !== null){
                const file = e.currentTarget.files[0]
                props.setInputFile(file)
                figureImage?.setAttribute('src', URL.createObjectURL(file))
                fileName && (fileName.textContent = file.name)
            }
            e.currentTarget.value = ''
        }

        return(
            <>
                <button type="button"className="frm-lb is-file input-main size-s"
                    onClick={e => {
                        inputFileRef.current?.click()
                }}>
                    <input 
                        ref={inputFileRef}
                        type="file"
                        className="file"
                        id="inputFile"
                        accept=".png,.jpeg,.jpg"
                        onChange={onFileInputChange}/>
                    <input type="text" id="file_upload0" defaultValue="ファイル選択"  /> 
                    <span>ファイルを選択</span><i className="ic-file"></i>

                </button>


                <span className="frm-file-val" id="fileName">選択されていません</span>

                <a className="fsz-s fsz-m1 fw-b link-ic rm-attachment-form" id="deletedisable" 
                    onClick={() => {
                        imageDelete()
                        props.deleteFile()
                    }}>×削除
                    
                </a>
            </>
        )
}

export function imageDelete(){
    const figureImage = document.querySelector('#figureImage');
    const fileName = document.querySelector('.frm-file-val');

    figureImage?.setAttribute('src', "")
    fileName && (fileName.textContent = '選択されていません')
}